"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerToJSON = exports.PartnerFromJSONTyped = exports.PartnerFromJSON = void 0;
function PartnerFromJSON(json) {
    return PartnerFromJSONTyped(json, false);
}
exports.PartnerFromJSON = PartnerFromJSON;
function PartnerFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PartnerFromJSONTyped = PartnerFromJSONTyped;
function PartnerToJSON(value) {
    return value;
}
exports.PartnerToJSON = PartnerToJSON;
